import HeadTittle from '../../../../../components/HeadTittle';
import routes from '../../../../../Routes/routes';
import DivContainerBody from '../../../../../components/DivContainerBody';
import ButtonAction from '../../../../../components/buttons/ButtonAction';
import {
    CompletePersonChip,
    IconDocumentCheck,
    IconVehicle,
    OutlinedCalendarIcon,
    PersonBook,
    PersonChipBlack,
    UpdateIconsOptions,
    VehicleChip,
} from '../../../../../components/buttons/IconButtons';
import {
    getModelSimpleSearch,
    userListToLabelEmailPhoneValue,
    vehicleListToLabel,
} from '../../../../../Apis/functions';
import CustomDateTimePicker from '../../../../../components/CustomDateTimePicker';
import { CompleteOrderApp } from '../../Functionality/CompleteOrderApp';
import { STATUS_MODEL } from '../../../../../enums/statusEnum';
import CustomAddChipSearch from '../../../../../components/CustomAddChipSearch';
import CustomCard from '../../../../../components/CustomCard';
import CustomGenericTittleIconDataChip from '../../../../../components/CustomGenericTittleIconDataChip';
import { SERVICE_ADVANCED_SEARCH_SIMPLE_SEARCH_USER } from '../../../../../reduxToolkit/Commons/CommonsApi';
import { TABLES } from './../../../../../Apis/Tables';
import NotInformation from '../../../../../components/NotInformation';
import OrderData from "./OrderData";
import {ORDER_SECTION} from "../../../Supplier/Model/Model";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 * @param isUpdateOrder
 * @returns {JSX.Element}
 * @constructor
 */
const CompleteOrder = ({ isUpdateOrder }) => {
    const {
        t,
        handelCompleteOrder,
        getOrderDetails,
        estimatedTimeOfArrivalDate,
        handleEstimatedTimeOfArrivalDateChange,
        emptyFields,
        selectedList,
        setSelectedList,
        selectedListVehicle,
        setSelectedListVehicle,
        supplierId
    } = CompleteOrderApp({ isUpdateOrder });

    return (
        <>
            <HeadTittle
                onBack={routes.suppliers.orders}
                name={getOrderDetails?.statusId === STATUS_MODEL.ORDER_INCOMING ? t('complete') :  t('update')}
            >
                <ButtonAction
                    id='btn_d_add'
                    name={getOrderDetails?.statusId === STATUS_MODEL.ORDER_INCOMING ? t('complete') : t('update')}
                    className='btn-icon-add'
                    Icon={isUpdateOrder ? UpdateIconsOptions : IconDocumentCheck}
                    onClick={() => {
                        handelCompleteOrder();
                    }}
                />
            </HeadTittle>

            <DivContainerBody>

                    <div className='row px-0 h-100'>
                        <div className='col-sm-12 col-md-4 col-lg-4 mb-lg-0 mb-md-3 mb-sm-3 pl-0'>
                            <OrderData
                                getOrderDetails={getOrderDetails}
                                section={ORDER_SECTION.COMPLETE_ORDER}
                            />
                        </div>
                        <div className='col-12 col-md-8'>
                            <CustomCard classes={'h-100'} classCard={'card-border-8px'} classContent={'p-0'}>
                                <div className='d-flex justify-content-between align-items-center m-3'>
                                    <CustomGenericTittleIconDataChip
                                        title={'delivery_entrance'}
                                        Icon={PersonBook}
                                        border={false}
                                        classNameTittleContainer={'mb-0'}
                                        titleBoxClass={'d-flex'}
                                    />
                                </div>
                               <div className={'border-bottom-shades-300 mb-3'} />
                                    <div className={'col-12 p-0 m-0'}>
                                            <CustomCard
                                                classes={'mb-3 mx-0'}
                                                classCard={'card-border-8px m-3'}
                                                classContent={'p-0 row'}
                                            >
                                                <div className={'d-flex align-items-center my-3'}>
                                                    <CustomGenericTittleIconDataChip
                                                        title={t('delivery_date')}
                                                        Icon={OutlinedCalendarIcon}
                                                        border={false}
                                                        classNameTittleContainer={'mb-0'}
                                                        titleBoxClass={'d-flex'}
                                                    />
                                                </div>
                                                <div className={'border-bottom-shades-300 mb-3'} />

                                                <div className='mt-3'>
                                                    <CustomDateTimePicker
                                                        id='dtp_co_estimated_time_of_arrival'
                                                        name={'estimatedTimeOfArrival'}
                                                        trans={'estimated_time_of_arrival'}
                                                        value={estimatedTimeOfArrivalDate}
                                                        openTo={'year'}
                                                        onChange={handleEstimatedTimeOfArrivalDateChange}
                                                        emptyFields={emptyFields}
                                                        required={true}
                                                        disablePast
                                                        allowSameDateSelection
                                                        ampm={false}
                                                    />
                                                </div>
                                            </CustomCard>
                                        </div>
                                    <div className='row'>
                                        <div className={'col-6 pr-0 m-0'}>
                                            <CustomCard
                                                classes={'mb-2'}
                                                classCard={'card-border-8px'}
                                                classContent={'p-0 row mb-3'}
                                            >
                                                <div className={'d-flex align-items-center my-3'}>
                                                    <CustomGenericTittleIconDataChip
                                                        title={t('assigned_employee')}
                                                        Icon={CompletePersonChip}
                                                        border={false}
                                                        classNameTittleContainer={'mb-0'}
                                                        titleBoxClass={'d-flex'}
                                                    />
                                                </div>
                                                <div className={'border-bottom-shades-300 mb-3'} />
                                                <div>
                                                    <CustomAddChipSearch
                                                        autocompleteId={'slt_co_assign_employees'}
                                                        buttonId={'btn_co_assign_employees'}
                                                        selectedList={selectedList}
                                                        setSelectedList={setSelectedList}
                                                        disabled={false}
                                                        label='employee'
                                                        emptyFields={emptyFields}
                                                        required={true}
                                                        reset={false}
                                                        hideButton={true}
                                                        keyId={'userId'}
                                                        showRenderOption={true}
                                                        maxLength={1}
                                                        showSubSection={true}
                                                        sanitizeDataList={userListToLabelEmailPhoneValue}
                                                        Icon={PersonChipBlack}
                                                        api={SERVICE_ADVANCED_SEARCH_SIMPLE_SEARCH_USER}
                                                        bodyApi={getModelSimpleSearch(TABLES.USER_BY_SUPPLIER_ID, {userId: supplierId})}
                                                    />
                                                    {selectedList?.length === 0 && (
                                                        <div className='h-50 '>
                                                            <NotInformation
                                                                card={true}
                                                                text={t('no_employee_selected')}
                                                            />
                                                        </div>
                                                    )}
                                                </div>
                                            </CustomCard>
                                        </div>
                                        <div className={'col-6 pl-0 m-0'}>
                                            <CustomCard
                                                classes={'mb-2'}
                                                classCard={'card-border-8px ml-3'}
                                                classContent={'p-0 row mb-3'}
                                            >
                                                <div className={'d-flex align-items-center my-3'}>
                                                    <CustomGenericTittleIconDataChip
                                                        title={t('assigned_vehicle')}
                                                        Icon={IconVehicle}
                                                        border={false}
                                                        classNameTittleContainer={'mb-0'}
                                                        titleBoxClass={'d-flex'}
                                                    />
                                                </div>
                                                <div className={'border-bottom-shades-300 mb-3'} />
                                                <div>
                                                    <CustomAddChipSearch
                                                        autocompleteId='slt_co_vehicle'
                                                        label='vehicle'
                                                        selectedList={selectedListVehicle}
                                                        setSelectedList={setSelectedListVehicle}
                                                        reset={false}
                                                        hideButton={true}
                                                        showRenderOption={true}
                                                        showSubSection={true}
                                                        emptyFields={emptyFields}
                                                        required={true}
                                                        maxLength={1}
                                                        sanitizeDataList={(list) =>
                                                        vehicleListToLabel(list, 'id', true, (props) => (
                                                            <VehicleChip
                                                                {...props}
                                                                className='icon-color-general-950'
                                                            />
                                                        ))
                                                        }
                                                        Icon={(props) => (
                                                            <VehicleChip {...props} className='icon-color-general-950' />
                                                        )}
                                                        api={SERVICE_ADVANCED_SEARCH_SIMPLE_SEARCH_USER}
                                                        bodyApi={getModelSimpleSearch(TABLES.VEHICLE_BY_SUPPLIER_ID, {userId: supplierId})}
                                                    />
                                                    {selectedListVehicle?.length === 0 && (
                                                        <NotInformation card={true} text={t('no_vehicle_selected')} />
                                                    )}
                                                </div>
                                            </CustomCard>
                                        </div>
                                    </div>
                            </CustomCard>

                        </div>
                    </div>

            </DivContainerBody>
        </>
    );
};

export default CompleteOrder;
